module.exports = __webpack_public_path__ + "static/img/30019 (3).cefa72d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30019 (3).webp
// module id = 0VJ3
// module chunks = 14